module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"subtitle":"Alle Foodspots auf einen Blick.","title":"Unsere Spots"},"en":{"subtitle":"All food spots at a glance.","title":"Our spots"}}')
  delete Component.options._Ctor
}
